<template>
  <div :class="['breadcrumbs', { 'breadcrumbs--overlay' : isOverlay }, { 'breadcrumbs--inverted' : isInverted }]">
    <template v-if="breadcrumbSegments" v-for="(segment, index) in breadcrumbSegments" :key="`${segment.url}-${segment.name}`">
      <nuxt-link v-if="segment.url" :to="segment.url" >{{ segment.name }}</nuxt-link>
      <span v-else>{{ segment.name }}</span>

      <span v-if="index < (breadcrumbSegments.length - 1)"> -> </span>
    </template>
    <template v-if="isAdmin">
      <span v-if="breadcrumbSegments.length" class="breadcrumbs__admin-link">|</span>
      <template v-if="! hideEdit">
        <a :href="editLink" class="breadcrumbs__admin-link" target="__blank">Edit</a>
        <span class="breadcrumbs__admin-link">|</span>
      </template>
      <a href="/wp-admin" class="breadcrumbs__admin-link" target="__blank">Dashboard</a>
      <template v-if="postId">
        <span class="breadcrumbs__admin-link">|</span>
        <span :class="['breadcrumbs__admin-link', { 'breadcrumbs--inverted' : isInverted }]">ID: {{ postId }}</span>
      </template>
      <template v-if="productNetPrices && productNetPrices.length">
        <span class="breadcrumbs__admin-link">|</span>
        <span class="breadcrumbs__admin-link">Net Price:</span>
        <template v-for="(price, idx) in productNetPrices" :key="idx">
          <span class="breadcrumbs__admin-link">
            <template v-if="price.name">{{ price.name }}: </template><span v-html="price.priceExTax || 'N/A'"></span>
          </span>
          <span v-if="idx < productNetPrices.length - 1" class="breadcrumbs__admin-link">|</span>
        </template>
      </template>
    </template>
    <template v-if="switchBackUrl">
      <span v-if="breadcrumbSegments.length || isAdmin" class="breadcrumbs__admin-link">|</span>
      <a :href="switchBackUrl" class="breadcrumbs__admin-link">Switch Back To {{ switchedFromUserName }}</a>
    </template>
    <template v-if="isContributor && !isAdmin && postId">
      <span v-if="breadcrumbSegments.length" class="breadcrumbs__admin-link">|</span>
      <span :class="['breadcrumbs__admin-link', { 'breadcrumbs--inverted' : isInverted }]">ID: {{ postId }}</span>
    </template>
  </div>
</template>

<script>
import { useUserStore } from "~/stores/user";

export default {
  props: {
    // [{segment.name, segment.url},]
    breadcrumbSegments: {
      type: Array,
      default: [],
    },
    postId: String|Number,
    isOverlay: Boolean,
    isInverted: Boolean,
    hideEdit: Boolean,
    productNetPrices: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {
      userStore: useUserStore(),
    }
  },
  computed: {
    isAdmin() {
      return this.userStore.isAdmin
    },
    isContributor() {
      return this.userStore.isContributor
    },
    editLink() {
      if (! this.postId) {
        return ''
      }
      return `/wp-admin/post.php?post=${this.postId}&action=edit`
    },
    switchBackUrl() {
      return this.userStore.user?.switchBackUrl
    },
    switchedFromUserName() {
      return this.userStore.user?.switchedFromUserName
    },
  },
}
</script>

<style lang="scss">
@import '~/common/scss/variables';

.breadcrumbs {
  text-align: left;
  font-size: 0.85rem;
  color: $colorGrey;
  margin-left: 14px;
  margin-top: 11px;

  &--overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 30;
  }

  &--inverted {
    color: $colorWhite;
    a {
      color: $colorWhite;
    }
  }

  &__admin-link {
    margin-left: 1rem;
  }

  &__post-id {
    color: $colorWhite;
  }
}
</style>
